
// Group Search Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Setup search for both desktop and mobile
  setupGroupSearch('group_search_input', 'group_search_results', 'group_search_clear');
  setupGroupSearch('group_search_input_mobile', 'group_search_results_mobile', 'group_search_clear_mobile');
});

function setupGroupSearch(inputId, resultsId, clearBtnId) {
  const searchInput = document.getElementById(inputId);
  const searchResults = document.getElementById(resultsId);
  const clearBtn = document.getElementById(clearBtnId);

  if (searchInput && searchResults) {
    let debounceTimer;

    // Function to update clear button visibility
    function updateClearButton() {
      if (clearBtn) {
        if (searchInput.value.trim().length > 0) {
          clearBtn.classList.remove('hidden');
        } else {
          clearBtn.classList.add('hidden');
        }
      }
    }

    // Initial state
    updateClearButton();

    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      const query = this.value.trim();

      // Update clear button visibility
      updateClearButton();

      if (query.length < 2) {
        searchResults.classList.add('hidden');
        searchResults.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        const url = searchInput.dataset.url + '?q=' + encodeURIComponent(query);

        fetch(url, {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.text())
        .then(html => {
          searchResults.innerHTML = html;
          searchResults.classList.remove('hidden');
        })
        .catch(error => {
          console.error('Search error:', error);
          searchResults.classList.add('hidden');
        });
      }, 300);
    });

    // Clear button click handler
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        searchInput.value = '';
        searchResults.classList.add('hidden');
        searchResults.innerHTML = '';
        clearBtn.classList.add('hidden');
        searchInput.focus();
      });
    }

    // Hide results when clicking outside
    document.addEventListener('click', function(e) {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target) && (!clearBtn || !clearBtn.contains(e.target))) {
        searchResults.classList.add('hidden');
      }
    });

    // Show results when focusing on input with existing value
    searchInput.addEventListener('focus', function() {
      if (this.value.trim().length >= 2 && searchResults.innerHTML.trim() !== '') {
        searchResults.classList.remove('hidden');
      }
    });
  }
}

// Loop through all showMoreLessButtons
document.querySelectorAll(".showMoreLessButtons").forEach((button) => {
  // Get the container and items related to the button
  let itemsContainer = document.getElementById(
    `itemsContainer${button.dataset.index}`
  );
  let items = itemsContainer.querySelectorAll(".item");

  // Toggle visibility of items when the button is clicked
  button.addEventListener("click", () => {
    let isExpanded = button.dataset.expanded === "true"; // Check if the button is currently expanded

    // Toggle visibility of items starting from the 7th item
    items.forEach((item, index) => {
      if (index >= 7) {
        item.classList.toggle("hidden", !isExpanded); // Toggle visibility based on the expanded state
      }
    });

    // Change button text and update its expanded state
    moreLess(isExpanded ? 'less' : 'more', button);
    button.dataset.expanded = !isExpanded; // Toggle expanded state

    // Toggle visibility of plus and minus icons
    let plusIcon = button.querySelector(".plusIcon");
    let minusIcon = button.querySelector(".minusIcon");
    plusIcon.classList.toggle("hidden", isExpanded);
    minusIcon.classList.toggle("hidden", !isExpanded);
  });

  // Set initial state of the button and items
  let initialExpandedState = items.length <= 7; // Check if total items <= 7
  if (!initialExpandedState) {
    // If there are more than 7 items
    items.forEach((item, index) => {
      if (index >= 7) {
        item.classList.add("hidden"); // Hide items starting from the 7th item
      }
    });
    moreLess('more', button) // Change button text to "Менее"
    button.dataset.expanded = "true"; // Set expanded state to true
  }

});

function moreLess(flag, btn) {
  let viewMore = btn.querySelector(".view-more");
  let viewLess = btn.querySelector(".view-less");
  if (flag === 'more') {
    viewMore.classList.remove('hidden');
    viewLess.classList.add('hidden');
  } else if (flag === 'less') {
    viewMore.classList.add('hidden');
    viewLess.classList.remove('hidden');
  }
}